import { Capabilities } from '@/auth-capabilities';
import { StatusBadge } from '@/components/ui';
import { ApiRegion } from '@/config';
import { useAuth } from '@/context/appContext';

export const QueueRegionChip = ({ region }: { region: ApiRegion }) => {
  const { hasAuth } = useAuth();
  if (!hasAuth(Capabilities.commonDataReviewerAdmin)) {
    return null;
  }
  return <StatusBadge>{region === ApiRegion.CA ? 'CA' : 'US'}</StatusBadge>;
};

export const queueItemTitlePrefix = (region: ApiRegion, canViewRegion: boolean) =>
  region === ApiRegion.US && canViewRegion ? 'US · queue #' : 'queue #';
